###
    @author Jaromír Navara [BG] <web@bagricek.cz>
    26.8.2016 4:14
###
(($, window) ->
  'use strict'
  # Define the plugin class
  class Pexeso
    $el: false
    rawPieces: {}, pieces: [], DOMPieces: []
    timer: 0, timerInterval: null, timeSpent: 0, points: 0, matchedCount: 0, isFreezedTimer: false
    currentlyFlipped: null, block: false, pexesoOptions: []
    options: {}
    timeofLastMatch: 0
    type: null
    isFirstClick: true
    ion: null

    constructor: (el, options) ->
      @debug("construct");
      @options = options
      self = this
      @$el = $(el)
      if(options.data == undefined )
        throw "parametr data je povinny"
      if(options.backPieceUrl == undefined )
        throw "parametr backPieceUrl je povinny"

      $.when(@_loadPieces()).then ->
        self.init()

    debug: (msg)->
      if(@options.debug)
        console.log msg

    _createBoard: ->
      @debug("_createBoard");
      $.each self.rawPieces, (key, val) =>
        @pieces.push({key: key, image: val.image, audio: val.audio})

    _createPairs: ->
      @debug("_createPairs");
      @pieces.push @pieces...

    init: ->
      @debug("init");
      @blocked = true
      @debug("blocked = #{@blocked}");
      @_createBoard()
      @_createPairs()
      @_shufflePieces()
      @_initAudioPieces()
      $("html").css("overflow","hidden")
      @_createDOMPieces()
      @_renderPieces()
      @initPauseTimer()
      $(window).resize @onResize

      $.when(@options.onLoad()).then =>
        @debug("@options.onLoad finished, starting timer");
        setTimeout =>
          @debug("timer ended, blocked = false");
          $("li.piece").flip(true)
          @blocked = false
        ,3000

    _loadPieces: ->
      @debug("_loadPieces");
      $.ajax
        url: @options.data
        type: "json",
        success: (data) =>
          self.rawPieces = data.pieces
          self.pexesoOptions = data.pexeso
          @type = data.pexeso.type

    onFirstclick: ->
      $.ajax
        url:   @options.startTimerUrl,
        type: "GET"

    stopTimer: (redirect = null)->
      $.ajax
        url:   @options.stopTimerUrl,
        type: "GET",
        data: {points: @points}
        success: ->
          if(redirect != null)
            location.href = redirect


    _shufflePieces: ->
      @debug("_shufflePieces");
      i = @pieces.length
      while --i > 0
        j = ~~(Math.random() * (i + 1))
        t = @pieces[j]
        @pieces[j] = @pieces[i]
        @pieces[i] = t

    _initAudioPieces: ->
      sounds = []
      for piece in @pieces
        if(piece.audio)
          sounds.push { name: piece.key, multiplay: true }

      $.ionSound({
        sounds: sounds,
        volume: 0.5,
        path: @options.audioPath,
        preload: true
      });

    _createDOMPieces: ->
      for piece in @pieces
        $pieceElem = $("<li></li>")
          .addClass("piece flipped")
          .attr("data-key", piece.key)
          .attr("data-image", piece.image)
          .click(@options.onPieceClick)
          .click(@pieceClicked)
          .click(@playPieceSoundOnClick)
          .on('flip:done', @flipDone)
        $("<div></div>")
          .css("background-image", "url(/uploads/original/#{piece.image})")
          .addClass("front")
          .appendTo($pieceElem)
        $("<div></div>")
        .css("background-image", "url(/uploads/original/#{@options.backPieceUrl})")
        .addClass("back")
        .appendTo($pieceElem)
        @DOMPieces.push($pieceElem)

    _getClosestSquared: (num)->
      if Math.sqrt(num) % 1 != 0
        num
      else
        @_getClosestSquared(num+1)

    _getSizes: ->
      if(!changes)
        changes = {}
      @debug("creating DOM");
      console.log $("nav#top").outerHeight()
      height = 0;

      if $(window).height() < 500
        # for too small screens use all height we can
        $("html").css("overflow","auto")
        height = @$el.height()
      else
        $("html").css("overflow","hidden")
        height = $(window).height() - 30 - $("nav#top").outerHeight()

      sizes =
        "width": @$el.width()
        "height": height
        "surface": @$el.width() * @$el.height()

      len = @_getClosestSquared(@pieces.length)
      lenSqrt = Math.sqrt(len)

      rows = lenSqrt

      smallerSizeToScaleFor = if sizes.height < sizes.width then sizes.height else sizes.width

      wrapperWidth = Math.ceil((smallerSizeToScaleFor) / Math.ceil(len / rows))
      margin = wrapperWidth * 0.05
      width = wrapperWidth - margin
      rowCount = Math.floor(smallerSizeToScaleFor / width)
      tmpWidth = rowCount * width
      wastedSpace = smallerSizeToScaleFor - tmpWidth
      margin = Math.floor(wastedSpace / (rowCount *2))

      { wrapperWidth: wrapperWidth, margin: margin, width: width, rowCount: rowCount, tmpWidth: tmpWidth, wastedSpace: wastedSpace }

    resizeBoardToFit: ->
      sizes = @_getSizes()
      for $piece in @DOMPieces
        $piece.css({ width: sizes.width, height: sizes.width, "margin": sizes.margin })

    onResize: =>
      @resizeBoardToFit()

    playPieceSoundOnClick: (e)=>
      $el = $(e.currentTarget)
      @_playElemSound($el)


    _playElemSound: ($el)->
      id = $el.data("key")
      if(@type == "voice")
        $.ionSound.play(id)

    _renderPieces: ->
      @debug("rendering DOM");
      for piece in @DOMPieces
        @$el.append(piece);
        piece.width(piece.height())
      @resizeBoardToFit()

    pieceClicked: (e)=>
      @debug("pieceClicked, blocked = #{@blocked}");
      if(@isFirstClick)
        @timer = 0
        @startTimer()
        @onFirstclick()
        @isFirstClick = false
      @options.onClick();
      if(@blocked)
        @debug("blocked, returning");
        e.preventDefault()
        return false
      else
        # clicked the same piece
        if(@currentlyFlipped && ($(e.target).parent("li").index() == @currentlyFlipped.index()))
          e.preventDefault()
          return false
        @_checkPiecesMatch($(e.target).parent("li"))


    _checkPiecesMatch: ($current) ->
      key = $current.attr("data-key")
      $current.flip(false);

      if(!@currentlyFlipped)
        @currentlyFlipped = $current;
        @blocked = false
        return false

      @currentlyFlipped.flip(false)
      if(key == @currentlyFlipped.attr("data-key"))
        @piecesMatch($current)
      else
        @piecesDontMatch($current)

    piecesMatch: ($current) ->
      @debug("piecesMatch");
      @currentlyFlipped.unbind("click").addClass("matched");
      $current.unbind("click").addClass("matched");

      $current.delay(600).animate {opacity: 0}, 600
      @currentlyFlipped.delay(600).animate {opacity: 0}, 600

      @currentlyFlipped = null
      @matchedCount += 2
      setTimeout =>
        @_playElemSound($current)
      ,1000

      @givePoints()
      @checkWin()

    piecesDontMatch: ($current) ->
      @debug("piecesNoMatch, blocked = true");
      @blocked = true

      if @type != "time"
        @points--
        @refreshPoints()

      setTimeout () =>
        @debug("piecesNoMatch flippedBack, blocked = false");
        @currentlyFlipped.flip(true)
        $current.flip(true)
        @blocked = false
        @currentlyFlipped = null
      ,1000

    _calculateSizes: ->
      sizes:
        width: @$el.width
        height: @$el.height


    flipDone: (e)->
      $(e.target).toggleClass("flipped")

    checkWin: ->
      # has won?
      if(@DOMPieces.length == @matchedCount)
        @clearTimer()
        @stopTimer(@options.victoryPage)

    startTimer: ->
      @debug("startTimer")
      @clearTimer()
      $("#navigation_pause").slideDown()
      @timerInterval = setInterval =>
        if(!@isFreezedTimer)
          @timer++
          @timeSpent++
          if @type == "time"
            @renderTimeSpent()
        #@debug("timer: #{@timer}")
      , 1000

    clearTimer: ->
      clearInterval @timerInterval

    initPauseTimer: ->
      @debug "initPauseTimer"
      $("#navigation_pause").click (e)=>
        @debug "navigation_pause click"
        @debug $(e.target)
        @isFreezedTimer = !@isFreezedTimer
        $button = $(e.target)
        $button.toggleClass("navigation_play")
        $button.toggleClass("navigation_pause")
        $("#overlay").fadeToggle()

    givePoints: ->
      @debug "givePoints"
      if @type == "time"
        #  nothing to do
      else if @type == "sound"
        @points += 10
        @refreshPoints()
      else
        @points += 10
        @refreshPoints()

    refreshPoints: ->
      $("#points #value").text(@points + " bodů")

    renderTimeSpent: ->
      #@debug "renderTimeSpent"
      minutes = Math.floor( @timeSpent/60 )
      seconds = Math.floor( @timeSpent - (minutes*60) )
      if(minutes < 10)
        minutes = "0" + minutes
      if(seconds < 10)
        seconds = "0" + seconds
      $("#points #value").text "#{minutes}:#{seconds}"



  # Define the plugin
  $.fn.extend Pexeso: (option, args...) ->
    @each ->
      $this = $(this)
      data = $this.data('Pexeso')

      if !data
        $this.data 'Pexeso', (data = new Pexeso(this, option))
      if typeof option == 'string'
        data[option].apply(data, args)

) window.jQuery, window